/**
 * 브라우저 경계. **`core/` 는 이 파일을 import 하지 않는다** — 반대 방향만 있다.
 * `tsconfig.core.json`(`lib: ES2022`, `types: []`)이 그것을 강제한다.
 *
 * 저장소 키를 **인자로 받는다.** 두 앱이 다른 키를 쓰기 때문이다 (`docs/22` §9) —
 * 앱은 `bloom.locale`, 콘솔은 `bloom.console.locale`. 오리진이 달라 충돌하지 않지만
 * 접두사를 붙여 둔다(같은 오리진에 두 `deviceId` 가 사는 문제를 이미 겪었다).
 */
import { isLocale } from '../core/locale.js';
/**
 * 사람이 고른 값을 읽는다. 유효하지 않으면 **없는 것으로 친다** — `'jp'`·`''`·손으로 넣은
 * 쓰레기 전부.
 *
 * **읽기가 실패해도 앱이 멈추지 않는다.** 사파리 프라이빗 모드에서 `localStorage` 접근이
 * 던진다. 그때는 `null` 을 주고 호출부가 시스템 언어 판정으로 내려간다.
 */
export function readSavedLocale(key) {
    try {
        const raw = window.localStorage.getItem(key);
        return isLocale(raw) ? raw : null;
    }
    catch {
        return null;
    }
}
/** 저장에 실패해도 화면은 그대로 돈다 — 언어는 이미 상태로 바뀌어 있다. */
export function writeSavedLocale(key, locale) {
    try {
        window.localStorage.setItem(key, locale);
    }
    catch {
        // 사파리 프라이빗 모드. 이번 세션 동안만 유지되고 다음 방문에 시스템 언어로 돌아간다
    }
}
/**
 * `<html lang>` 을 갱신한다 (`docs/22` §10).
 *
 * 스크린리더의 발음이 갈리고, 브라우저의 한글 폰트 폴백과 줄바꿈 규칙이 갈린다 —
 * 영어 화면에 `lang="ko"` 가 남아 있으면 긴 영문 단어의 줄바꿈이 어색해진다.
 */
export function applyDocumentLang(locale) {
    document.documentElement.lang = locale;
}
//# sourceMappingURL=storage.js.map